import { Button, makeStyles } from "@material-ui/core"
import { Link } from "react-router-dom"

const useStyles2 = makeStyles(theme => ({
    hero: {
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        height: '10rem',
        fontSize: '3rem',
        textTransform: 'uppercase',
    },
    heroLink: {
        textDecoration: 'none',
    }
}))

// Extreme hero button
const HeroButton = ({ className, children, to }: { className?: string, children: React.ReactNode, to: string }) => {
    const classes = useStyles2()
    return (
        <Link className={classes.heroLink} to={to}>
            <Button className={classes.hero} type='button'>{children}</Button>
        </Link>
    )
}

export default HeroButton